import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import bgMusic from "../assets/background.mp3";
import backgroundImage from "../assets/Animated_Logo_GIF.gif";
import "./Dashboard.css";
import siemens_logo from "../assets/siemens_logo.svg";

const Rules = () => {
  const navigate = useNavigate();
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;

    const handleUserInteraction = () => {
      if (audio) {
        audio.muted = false; // Unmute to allow playback
        audio
          .play()
          .then(() => {
            console.log("Audio started playing");
            // Remove event listeners after successful play
            document.removeEventListener("mousemove", handleUserInteraction);
            document.removeEventListener("click", handleUserInteraction);
            document.removeEventListener("touchstart", handleUserInteraction);
          })
          .catch((error) => console.error("Audio play failed:", error));
      }
    };

    // Add event listeners
    document.addEventListener("mousemove", handleUserInteraction);
    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("touchstart", handleUserInteraction);

    return () => {
      // Cleanup event listeners when the component unmounts
      document.removeEventListener("mousemove", handleUserInteraction);
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 5%",
      }}
    >
      <div style={{ position: "absolute", top: "20px", left: "30px" }}>
        {/*<h2 style={{ fontSize: "2.9rem", fontWeight: "bold", color: "#fff" }}>
          COACT
        </h2>*/}
         <img
          src={siemens_logo}
          alt="logo"
          style={{ width: "150px", height: "80px" }}
        />       
       </div>

      <div style={{ maxWidth: "50%" }}>
        <h1 style={{ fontSize: "28px", fontWeight: "bold", color: "#00FFB9" }}>
          Siemens Sustainability Quiz Rules
        </h1>
        <li>
          <b>30 seconds to answer each question.</b>
        </li>
        <li>
          <b>Get all answers correct to win.</b>
        </li>
        <li>
          <b>Top the leaderboard by answering the fastest!</b>
        </li>

        <button
          onClick={() => navigate("/quiz")}
          style={{
            backgroundImage: "linear-gradient(to right, #00E6DC, #00FFB9)",
            border: "2px solid #00d8ff",
            borderRadius: "8px",
            padding: "10px 20px",
            fontSize: "1.1rem",
            fontWeight: "bold",
            marginTop: "8rem",
          }}
        >
          Start Quiz
        </button>
      </div>

      {/* <div
        style={{
          width: "40%",
          height: "40%",
          borderRadius: "50%",
          overflow: "hidden",
        }}
      >
        <img
          src={backgroundImage}
          alt="Circular Cutout"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div> */}

      {/* Background Music */}
      <audio ref={audioRef} loop muted>
        <source src={bgMusic} type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default Rules;
